import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=2cfc320e&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=ts"
export * from "./UpdateProfile.vue?vue&type=script&lang=ts"
import style0 from "./UpdateProfile.vue?vue&type=style&index=0&id=2cfc320e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc320e",
  null
  
)

export default component.exports